import Dashboard from "../pages/Dashboard"
import { signup } from "../redux/actions/authActions"

const baseUrl = process.env.REACT_APP_API_URL

const HttpService = {
    loginUrl: baseUrl + "admin/login",
    signupUrl: baseUrl + "admin/school/register",
    verify_signUp_Otp: baseUrl + "admin/school/verify-otp",
    school_admin_change_password: baseUrl + "admin/school/change-password",
    verifyTokenUrl: baseUrl + 'admin/verify-token',
    school_delete: baseUrl + "admin/school/delete",
    school_add: baseUrl + 'admin/school/store',
    school_list: baseUrl + 'admin/school/fetch',
    school_show: baseUrl + 'admin/school/show',
    dashboard: baseUrl + 'admin/dashboard/',
    board_management_list: baseUrl + 'admin/board-management/fetch',
    board_management_add: baseUrl + 'admin/board-management/store',
    board_management_show: baseUrl + 'admin/board-management/show',
    board_management_remove: baseUrl + 'admin/board-management/delete',
    board_management_status: baseUrl + 'admin/board-management/status',
    board_notes_list: baseUrl + 'admin/board-management/notes/fetch',
    board_notes_add: baseUrl + 'admin/board-management/notes/store',
    board_notes_show: baseUrl + 'admin/board-management/notes/show',
    board_notes_delete: baseUrl + 'admin/board-management/notes/delete',
    board_files_list: baseUrl + 'admin/board-management/files/fetch',
    board_files_add: baseUrl + 'admin/board-management/files/store',
    board_files_show: baseUrl + 'admin/board-management/files/show',
    board_files_delete: baseUrl + 'admin/board-management/files/delete',
    board_contributions_list: baseUrl + 'admin/board-management/contributions/fetch',
    board_contributions_add: baseUrl + 'admin/board-management/contributions/store',
    board_contributions_show: baseUrl + 'admin/board-management/contributions/show',
    board_contributions_delete: baseUrl + 'admin/board-management/contributions/delete',
    forgotPasswordUrl: baseUrl + 'admin/forgot-password',
    verifyOtp: baseUrl + 'admin/otp-verify',
    resetPasswordUrl: baseUrl + 'admin/reset-password',
    school_management_list: baseUrl + 'admin/management/fetch',
    school_management_add: baseUrl + 'admin/management/store',
    school_management_show: baseUrl + 'admin/management/show',
    school_management_remove: baseUrl + 'admin/management/delete',
    school_management_status: baseUrl + 'admin/management/status',
    teacher_management_list: baseUrl + 'admin//management/fetch',
    teacher_management_add: baseUrl + 'admin/management/store',
    teacher_management_show: baseUrl + 'admin/management/show',
    teacher_management_remove: baseUrl + 'admin/management/delete',
    teacher_management_status: baseUrl + 'admin/management/status',
    school_notes_list: baseUrl + 'admin/management/notes/fetch',
    school_notes_add: baseUrl + 'admin/management/notes/store',
    school_notes_show: baseUrl + 'admin/board-management/notes/show',
    school_notes_delete: baseUrl + 'admin/management/notes/delete',
    school_files_list: baseUrl + 'admin/management/files/fetch',
    school_files_add: baseUrl + 'admin/management/files/store',
    school_files_show: baseUrl + 'admin/management/files/show',
    school_files_delete: baseUrl + 'admin/management/files/delete',
    school_contributions_list: baseUrl + 'admin/management/contributions/fetch',
    school_contributions_add: baseUrl + 'admin/management/contributions/store',
    school_contributions_show: baseUrl + 'admin/management/contributions/show',
    school_contributions_delete: baseUrl + 'admin/management/contributions/delete',
    admission_guidelines_list: baseUrl + 'admin/admission-guideline/fetch',
    admission_guidelines_add: baseUrl + 'admin/admission-guideline/store',
    admission_guidelines_show: baseUrl + 'admin/admission-guideline/show',
    admission_guidelines_delete: baseUrl + 'admin/admission-guideline/delete',
    fee_structure_list: baseUrl + 'admin/fee-structure/fetch',
    fee_structure_add: baseUrl + 'admin/fee-structure/store',
    fee_structure_show: baseUrl + 'admin/fee-structure/show',
    fee_structure_delete: baseUrl + 'admin/fee-structure/delete',
    admission_faqs_list: baseUrl + 'admin/admission-faq/fetch',
    admission_faqs_add: baseUrl + 'admin/admission-faq/store',
    admission_faqs_show: baseUrl + 'admin/admission-faq/show',
    admission_faqs_delete: baseUrl + 'admin/admission-faq/delete',
    calendar_event_add: baseUrl + 'admin/education/calendar/event/store',
    calendar_event_list: baseUrl + 'admin/education/calendar/event/fetch',
    calendar_event_delete: baseUrl + 'admin/education/calendar/event/delete',
    academic_calendar_add: baseUrl + 'admin/education/academic/store',
    academic_calendar_list: baseUrl + 'admin/education/academic/fetch',
    academic_calendar_delete: baseUrl + 'admin/education/academic/delete',
    performance_add: baseUrl + 'admin/education/performance/store',
    performance_list: baseUrl + 'admin/education/performance/fetch',
    performance_show: baseUrl + 'admin/education/performance/show',
    performance_delete: baseUrl + 'admin/education/performance/delete',
    subject_add: baseUrl + 'admin/education/subject/store',
    subject_list: baseUrl + 'admin/education/subject/fetch',
    subject_show: baseUrl + 'admin/education/subject/show',
    subject_delete: baseUrl + 'admin/education/subject/delete',
    facility_add: baseUrl + 'admin/education/facility/store',
    facility_list: baseUrl + 'admin/education/facility/fetch',
    facility_show: baseUrl + 'admin/education/facility/show',
    facility_delete: baseUrl + 'admin/education/facility/delete',
    stream_add: baseUrl + 'admin/education/stream/store',
    stream_list: baseUrl + 'admin/education/stream/fetch',
    stream_show: baseUrl + 'admin/education/stream/show',
    stream_delete: baseUrl + 'admin/education/stream/delete',
    project_add: baseUrl + 'admin/education/project/store',
    project_list: baseUrl + 'admin/education/project/fetch',
    project_show: baseUrl + 'admin/education/project/show',
    project_delete: baseUrl + 'admin/education/project/delete',
    news_add: baseUrl + 'admin/news/store',
    news_list: baseUrl + 'admin/news/fetch',
    news_show: baseUrl + 'admin/news/show',
    news_delete: baseUrl + 'admin/news/delete',
    department_add: baseUrl + 'admin/department/store',
    department_list: baseUrl + 'admin/department/fetch',
    department_show: baseUrl + 'admin/department/show',
    department_delete: baseUrl + 'admin/department/delete',
    department_status: baseUrl + 'admin/department/status',
    sports_add: baseUrl + 'admin/extracurricular/sports/store',
    sports_list: baseUrl + 'admin/extracurricular/sports/fetch',
    sports_show: baseUrl + 'admin/extracurricular/sports/show',
    sports_delete: baseUrl + 'admin/extracurricular/sports/delete',
    arts_add: baseUrl + 'admin/extracurricular/arts/store',
    arts_list: baseUrl + 'admin/extracurricular/arts/fetch',
    arts_show: baseUrl + 'admin/extracurricular/arts/show',
    arts_delete: baseUrl + 'admin/extracurricular/arts/delete',
    clubs_add: baseUrl + 'admin/extracurricular/clubs/store',
    clubs_list: baseUrl + 'admin/extracurricular/clubs/fetch',
    clubs_show: baseUrl + 'admin/extracurricular/clubs/show',
    clubs_delete: baseUrl + 'admin/extracurricular/clubs/delete',
    leadership_add: baseUrl + 'admin/extracurricular/leadership/store',
    leadership_list: baseUrl + 'admin/extracurricular/leadership/fetch',
    leadership_show: baseUrl + 'admin/extracurricular/leadership/show',
    leadership_delete: baseUrl + 'admin/extracurricular/leadership/delete',
    religious_add: baseUrl + 'admin/extracurricular/religious/store',
    religious_list: baseUrl + 'admin/extracurricular/religious/fetch',
    religious_show: baseUrl + 'admin/extracurricular/religious/show',
    religious_delete: baseUrl + 'admin/extracurricular/religious/delete',
    volunteering_add: baseUrl + 'admin/extracurricular/volunteering/store',
    volunteering_list: baseUrl + 'admin/extracurricular/volunteering/fetch',
    volunteering_show: baseUrl + 'admin/extracurricular/volunteering/show',
    volunteering_delete: baseUrl + 'admin/extracurricular/volunteering/delete',
    school_role_add:baseUrl+'admin/school/role/store',
    school_role_list:baseUrl+'admin/school/role/fetch',
    school_role_show:baseUrl+'admin/school/role/show',
    school_role_delete:baseUrl+'admin/school/role/delete',
    school_subadmin_add:baseUrl+'admin/school/subadmin/store',
    school_subadmin_list:baseUrl+'admin/school/subadmin/fetch',
    school_subadmin_show:baseUrl+'admin/school/subadmin/show',
    school_subadmin_delete:baseUrl+'admin/school/subadmin/delete',
    school_policy_add:baseUrl+'admin/school/policy/store',
    school_policy_show:baseUrl+'admin/school/policy/show',
    school_policy_delete:baseUrl+'admin/school/policy/delete',
    school_terms_add:baseUrl+'admin/school/terms/store',
    school_terms_show:baseUrl+'admin/school/terms/show',
    school_statement_add:baseUrl+'admin/school/statement/store',
    school_statement_show:baseUrl+'admin/school/statement/show',
    school_about_add:baseUrl+'admin/school/about/store',
    school_about_show:baseUrl+'admin/school/about/show',
    school_cms_add:baseUrl+'admin/school/cms/store',
    school_cms_list:baseUrl+'admin/school/cms/fetch',
    school_cms_show:baseUrl+`admin/school/cms/show`,
    school_cms_delete:baseUrl+`admin/school/cms/delete`,
    school_contact_field_add:baseUrl+'admin/school/contactfield/store',
    school_contact_field_show:baseUrl+'admin/school/contactfield/show',
    school_profile_update:baseUrl+'admin/school/profile/update',
    school_profile_show:baseUrl+'admin/school/profile/show',
    admin_school_approval_list: baseUrl + 'admin/superadmin/school/fetch',
    admin_school_approve: baseUrl + 'admin/superadmin/school/approve',
    admin_school_reject: baseUrl + 'admin/superadmin/school/reject',
    admin_school_review: baseUrl + 'admin/superadmin/school/review',
    admin_school_list: baseUrl+ 'admin/superadmin/school-list/fetch',
    admin_search_school_list: baseUrl+ 'admin/superadmin/search-school-list/fetch',
    admin_school_add: baseUrl+ 'admin/superadmin/school-list/store',
    admin_school_show: baseUrl+ 'admin/superadmin/school-list/show',
    admin_school_delete: baseUrl+ 'admin/superadmin/school-list/delete',
    admin_school_status_update: baseUrl+ 'admin/superadmin/school-list/status',
    admin_content_list: baseUrl + 'admin/superadmin/cms/fetch',
    admin_content_add: baseUrl + 'admin/superadmin/cms/store',
    admin_content_show: baseUrl + 'admin/superadmin/cms/show',
    admin_content_delete: baseUrl + 'admin/superadmin/cms/delete',
    admin_content_status:baseUrl + 'admin/superadmin/cms/status',
    admin_activity_logs: baseUrl+"admin/activity",
    logs_list_with_date_range: baseUrl+"admin/activity/logs-list-with-date-range",
    

}

export default HttpService